import { useEffect, useState } from "react";
import { addSubscription, getAllUsers, getNumberOfUsers } from "../../HTTP/admin";

export default function AddSubscription() {

  const localUser = JSON.parse(localStorage.getItem("user"))
    if (!localUser.super_admin && localUser.admin_access !== 3) {
        window.location.href = '/'
    }

    const [nbUsers, setNbUsers] = useState(0);
    const [users, setUsers] = useState([])

    useEffect(() => {
        const funNumberUsers = async () => {
                const numberUsers = await getNumberOfUsers('ac')
                setNbUsers(numberUsers)
        }
        funNumberUsers()
    }, [])

    useEffect(() => {
        const funSearchUsers = async () => {
            const searchUsers = await getAllUsers(0, nbUsers, 'ac')
            setUsers(searchUsers)
        }
        funSearchUsers()
      }, [nbUsers])

    const [formData, setFormData] = useState({
        user_id: 0,
        start_date: '',
        end_date: '',
      });

      const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prevData => ({
          ...prevData,
          [name]: type === 'checkbox' ? checked : value
        }));
        console.log(formData)
      };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const request = {
          user_id: parseInt(formData.user_id),
          start_date : formData.start_date,
          end_date : formData.end_date,
        }
        try {
          const res = await addSubscription(request)
          if (res) {
            alert("Subscription created")
            window.location.href = '/admin/subscription'
          } else {
            alert("An error occured while creating the subscription")
          }
        } catch (err) {
          console.log(err)
          alert("An error occured while saving the subscription");
        }
    }

    return (
        <div className="max-w-md mx-auto mt-8 p-6 bg-white rounded-lg shadow-md">
          <h2 className="text-2xl font-bold mb-6 text-center">Formulaire Abonnement</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label htmlFor="country" className="block text-gray-700 text-sm font-bold mb-2">
                Utilisateur
              </label>
              <select onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" name="user_id">
                  {
                     users.map((u, i) => <option value={u.id} key={i}>{u.firstname} {u.lastname}</option>)
                  }
                </select>
            </div>
            <div className="mb-4">
              <label htmlFor="start_date" className="block text-gray-700 text-sm font-bold mb-2">
                Date de début d'abonnement
                <input type="datetime-local" value={formData.start_date} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" name="start_date"/>
              </label>
              
            </div>
            <div className="mb-4">
              <label htmlFor="end_date" className="block text-gray-700 text-sm font-bold mb-2">
                Date de fin d'abonnement
                <input type="datetime-local" value={formData.end_date} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" name="end_date"/>
              </label>
              
            </div>
            <div className="flex items-center justify-end">
              <button
                type="submit"
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              >
                Enregistrer
              </button>
            </div>
          </form>
        </div>
    )
}